import { motion, useTransform } from "framer-motion";
import { Home, Building2 } from "lucide-react";
import { EXPERTISE } from "../data/site";

const ICONS = { residential: Home, commercial: Building2 };

const Card = ({ item, progress, from, index }) => {
  const inStart = 0.4 + index * 0.07;
  const x = useTransform(progress, [inStart, inStart + 0.13], [from, 0]);
  const opacity = useTransform(
    progress,
    [inStart, inStart + 0.1, 0.78, 0.86],
    [0, 1, 1, 0]
  );
  const Icon = ICONS[item.id];

  return (
    <motion.div
      style={{ x, opacity }}
      data-testid={`expertise-card-${item.id}`}
      className="w-full max-w-md border border-white/10 bg-navy-800/55 p-8 shadow-[0_24px_60px_rgba(0,0,0,0.45)] backdrop-blur-xl md:p-10"
    >
      <div className="mb-6 flex h-11 w-11 items-center justify-center border border-gold/30">
        <Icon className="h-5 w-5 text-gold" strokeWidth={1.25} />
      </div>
      <h3 className="font-serif text-2xl font-semibold text-white">
        {item.title}
      </h3>
      <p className="mt-3 text-xs font-light leading-relaxed tracking-wide text-slate-300">
        {item.subtitle}
      </p>
      <div className="mt-6 h-px w-full bg-white/10" />
      <ul className="mt-6 space-y-3">
        {item.points.map((point) => (
          <li
            key={point}
            className="flex items-center gap-3 text-[0.8rem] font-light tracking-wide text-slate-200"
          >
            <span className="h-px w-5 bg-gold/70" />
            {point}
          </li>
        ))}
      </ul>
    </motion.div>
  );
};

export default function Expertise({ progress }) {
  const headOpacity = useTransform(
    progress,
    [0.38, 0.46, 0.78, 0.86],
    [0, 1, 1, 0]
  );

  return (
    <div
      className="pointer-events-none absolute inset-0 z-20 flex flex-col items-center justify-center px-6"
      data-testid="expertise-overlay"
    >
      <motion.div style={{ opacity: headOpacity }} className="mb-10 text-center">
        <p className="text-[0.6rem] font-semibold uppercase tracking-[0.45em] text-gold md:text-xs">
          Our Expertise
        </p>
        <h2 className="mt-4 font-serif text-2xl font-semibold text-white sm:text-3xl lg:text-4xl">
          Two Disciplines. One Standard.
        </h2>
      </motion.div>
      <div className="flex w-full max-w-5xl flex-col items-center gap-6 md:flex-row md:items-stretch md:justify-center md:gap-10">
        {EXPERTISE.map((item, i) => (
          <Card
            key={item.id}
            item={item}
            index={i}
            progress={progress}
            from={i === 0 ? -180 : 180}
          />
        ))}
      </div>
    </div>
  );
}
